var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"alert show",style:(_vm.color)},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.info)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }